import React, { useEffect, useState } from "react";
import Select from "react-select";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { getCompanyList, getPermissionList } from "./_redux/Crud";
import * as actions from "./_redux/Actions";
import SVG from "react-inlinesvg";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import _ from 'lodash';

const CompanySelectInput = (props) => {
  const [allCompany, setAllCompany] = useState(null);
  const [company, setCompany] = useState(null);
  let history = useHistory();

  const dispatch = useDispatch();
  const customStyles = {
    control: (base, state) => ({
      ...base,
// boxShadow: state.isFocused ? null : null,
      "&:hover": {
// Overwrittes the different states of border
        borderColor: state.isFocused ? "red" : "transparent"
      }
    })
  };

  useEffect(() => {
    getCompanyListAPICall();
    getPermissionListAPICall();
  }, []);

  const getCompanyListAPICall = async () => {
    if (localStorage?.getItem("token")) {

      try {
        let temp = [];
        let response = await getCompanyList();
        if (response) {
          const userdata = JSON.parse(localStorage.getItem("userData"));
          const userCompany = userdata?.company || [];
          const isAdmin = false;
          if (isAdmin) {
// Admin user, show all companies
            temp = response.data;
          } else {
            response.data.forEach((item) => {
              if (userCompany.includes(item._id)) {
                temp.push(item);
              }
            });
          }
          setAllCompany(temp);

          const companydata = JSON.parse(localStorage.getItem("company"));
          let defaultCompanyName = "GamerJi E-Sports Private Limited.";
          
          // Check if the default company name exists in the list
          let defaultCompany = temp.find(company => company.name === defaultCompanyName);
          if (!defaultCompany && temp.length > 0) {
            defaultCompany = temp[0];
          }

          if (companydata) {
            defaultCompanyName = companydata.name;
            defaultCompany = temp.find(company => company.name === defaultCompanyName);
          }

          if (defaultCompany) {
            updateCountry(defaultCompany);
          }
        }
      } catch (error) {
        // Handle error
      }
    } else {
      window.location.reload();
    }
  };

  const getPermissionListAPICall = async () => {
//console.log("getPermissionList>>>>>>>>>>>>>>>>>>>>>>>>>>")
    if (localStorage?.getItem("token")) {
      try {
        const userdata = JSON.parse(localStorage.getItem("userData"));
        const permission = JSON.parse(localStorage.getItem("permissions"));
const refresh = localStorage.getItem("refresh");

      //  console.log("old-permission>>>>>>>>>>>>>>>>>>>>>>>>>>refresh",refresh)
        const countrydata = JSON.parse(localStorage.getItem("country"));
        const companydata = JSON.parse(localStorage.getItem("company"));
        let payload = {
          company: companydata._id,
          userId: userdata.id,
        };
        let response = await getPermissionList(payload);
        if (response && response?.data) {
          if(permission){
            if(permission?._id && permission?._id===response?.data?._id){
              //  console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>same permission")
              //  if(localStorage.getItem("refresh")){
                localStorage.setItem("refresh",false);
              const areEqual = _.isEqual(permission, response.data);
              // console.log("Objects are equal:", areEqual);
                if(!areEqual){
                  localStorage.setItem("permissions", JSON.stringify( response.data));
                  // console.log("permissionUpdated>>onHardRefresh>>>>>>>>>>>>>>>>>>>>>>>>,",permission,response.data);
                 // setTimeout(() => {
                    window.location.reload();
                //}, 1000);
                // }
               }
              }else {
              // console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>different permission")
              localStorage.setItem("permissions", JSON.stringify( response.data));
const permission = JSON.parse(localStorage.getItem("permissions"));
              // console.log("permissionUpdated>>>>>>>>>>>>>>>>>>>>>>>>>>");
             // setTimeout(() => {
                window.location.reload();
              // }, 1000);
              }
            }else{
             
          }
         
           
           
        }else{
         // console.log("permissionUpdated>>>>>permission not found>>>>>>>>>>>>>>>>>>>>>");
          localStorage.setItem("permissions", JSON.stringify( {
            pagePermission: ["dashboard.page.master"],
            buttonPermission: ["dashborad.home.list"],
            apiPermission: [],
            company: [],
            country: [],
            role: ""
          }));
          history.push("/");
        }
      } catch (error) {
        localStorage.setItem("permissions", JSON.stringify({
          pagePermission: ["dashboard.page.master"],
          buttonPermission: ["dashborad.home.list"],
          apiPermission: [],
          company: [],
          country: [],
          role: ""
        }));
      }
    } else {
      localStorage.setItem("permissions", JSON.stringify({
        pagePermission: ["dashboard.page.master"],
        buttonPermission: ["dashborad.home.list"],
        apiPermission: [],
        company: [],
        country: [],
        role: ""
      }));
    }
    return false;
  };

  const updateCountry = async (e) => {
    const companydata = JSON.parse(localStorage.getItem("company"));
    if (companydata?._id !== e?._id) {
      setCompany(e);
      await dispatch(actions.saveCompany(e));
      localStorage.setItem("company", JSON.stringify(e));
      getPermissionListAPICall();
    } else {
      setCompany(e);
      await dispatch(actions.saveCompany(e));
      localStorage.setItem("company", JSON.stringify(e));
    }
  };

  return (
    <Select
      placeholder="Select Company"
      value={company}
      options={allCompany}
      onChange={updateCountry}
      styles={customStyles}
      getOptionValue={(option) => option.name}
      getOptionLabel={(e) => (
        <div style={{ display: "flex", alignItems: "center", backgroundColor: 'transparent' }}>
          {e?.svg ? (
            <SVG src={toAbsoluteUrl("/media/svg/icons/Communication/Flag.svg")} />
          ) : (
            <img
              height={25}
              width={30}
            />
          )}
          <span style={{ marginLeft: 5 }}>{e.name}</span>
        </div>
      )}
    />
  );
};

export default CompanySelectInput;
